import { render, staticRenderFns } from "./InquiryManagement.vue?vue&type=template&id=ea7822a8&scoped=true&"
import script from "./InquiryManagement.vue?vue&type=script&lang=js&"
export * from "./InquiryManagement.vue?vue&type=script&lang=js&"
import style0 from "./InquiryManagement.vue?vue&type=style&index=0&id=ea7822a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7822a8",
  null
  
)

export default component.exports